import { useContext, useEffect, useState } from "react";
import { UPDATE_CURRENT_SESSION_TEST_DATA } from "../../../../../store/actions";
import { Context } from "../../../../../store/store";
import { Button, Typography } from "../../components";
import "./styles.scss";
import { handlePdfFileDownload, insertVariablesIntoHtml } from "./utils";
import Visualization from "./visualization";
import { REPORT_TYPE } from "../../../../Tool/Client/Form";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import Loader from "../../../../../components/Loader";

function TestResults() {
  const [state, dispatch] = useContext(Context);
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const {
    publicTest: { sets, startHtml, finalHtml, entries, client },
  } = state;

  const lastEntry = entries[entries.length - 1];

  async function handleDownloadPdfClick() {
    setIsLoading(true);
    try {
      await handlePdfFileDownload(
        lastEntry.sessionId,
        t("frontend.test.reportFileName", "biwe-cube-export.pdf")
      );
    } catch {
      toast.error(
        t(
          "frontend.test.pdfExportError",
          "Error exporting PDF. Please try again later."
        )
      );
    }
    setIsLoading(false);
  }

  const renderScale = (setId, scale, i) => {
    const entry = entries.find(entry => entry.testSetId === setId) || {};
    const forming = entry[`S${i + 1}F`];
    return (
      <div>
        <Typography h1 center>
          {scale.scaleName}
        </Typography>
        <div
          className="tg_info"
          dangerouslySetInnerHTML={{ __html: scale.scaleReportInfo }}
        />
        <Visualization scale={scale} value={forming} />
        {forming && (
          <div
            className="tg_info"
            dangerouslySetInnerHTML={{
              __html: scale[`forming${forming}Report`],
            }}
          />
        )}
      </div>
    );
  };

  useEffect(() => {
    dispatch({
      type: UPDATE_CURRENT_SESSION_TEST_DATA,
      payload: { sessionId: null },
    });
  }, [dispatch]);

  return (
    <div className="tg_page tg_test-results-page">
      <div className="header">
        <div
          className="tg_info"
          dangerouslySetInnerHTML={{
            __html: insertVariablesIntoHtml(startHtml, entries),
          }}
        />
      </div>
      {client.reportType !== REPORT_TYPE.culturlytics &&
        !client?.disableIndividualReport && (
          <div className="tg_column">
            {sets.map((set, i) => (
              <div key={i} className="tg_set-result">
                <div
                  className="tg_info"
                  dangerouslySetInnerHTML={{ __html: set.info.reportInfo }}
                />
                <div>
                  {set.scales.map((scale, i) => (
                    <div className="tg_test-result" key={i}>
                      {renderScale(set._id, scale, i)}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      {(client.reportType === REPORT_TYPE.cockpit ||
        client.reportType === REPORT_TYPE.culturlytics) && (
        <div className="export-container">
          {!client.disableIndividualReport && (
            <Button onClick={handleDownloadPdfClick} large disabled={isLoading}>
              {t("frontend.test.downloadPdf", "Download PDF")}
            </Button>
          )}
        </div>
      )}
      {isLoading && (
        <div className="export-loader-container">
          <Loader />
        </div>
      )}
      <div className="footer">
        <div
          className="tg_info"
          dangerouslySetInnerHTML={{
            __html: insertVariablesIntoHtml(finalHtml, entries),
          }}
        />
      </div>
    </div>
  );
}

export default TestResults;
